import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { incentivesClient } from '#pplx_generated/typespec/rest/incentives/client.js';
export const handleCometActivationIncentive = async ({ reason, }) => {
    try {
        const { data, error } = await incentivesClient.POST('/rest/incentives/comet-activation', reason, {
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw error;
        }
        return data;
    }
    catch (err) {
        logger.error('Failed to handle comet activation incentive', err);
        return null;
    }
};
//# sourceMappingURL=incentivesQueries.js.map